export const PREDICTION_HORIZON_DAYS = 10;

function startOfLocalDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function predictionDateFromToday(dayOffset, hour = 8) {
  const date = startOfLocalDay(new Date());
  date.setDate(date.getDate() + dayOffset);
  date.setHours(hour, 0, 0, 0);
  return date.toISOString();
}

export function filterForwardPredictions(
  predictions,
  horizonDays = PREDICTION_HORIZON_DAYS,
) {
  if (!predictions?.length) return [];

  const today = startOfLocalDay(new Date());
  const end = new Date(today);
  end.setDate(end.getDate() + horizonDays);

  return [...predictions]
    .filter((prediction) => {
      const day = startOfLocalDay(new Date(prediction.prediction_date));
      return day >= today && day < end;
    })
    .sort(
      (a, b) => new Date(a.prediction_date) - new Date(b.prediction_date),
    )
    .slice(0, horizonDays);
}

const MOCK_DAILY_WEIGHTS = [280000, 320000, 250000, 200000, 310000, 420000, 290000, 260000, 220000, 330000];
const MOCK_DAILY_SCORES = [8, 9, 5, 7, 9, 8, 8, 6, 7, 9];

export function buildMockZonePredictions() {
  return MOCK_DAILY_WEIGHTS.map((net_weight, index) => ({
    id: `mock-${index + 1}`,
    prediction_date: predictionDateFromToday(index),
    net_weight,
    score: MOCK_DAILY_SCORES[index],
  }));
}
